















import { Component, Vue } from "vue-property-decorator";

@Component
export default class CapabilitiesCard extends Vue {
  items: any[] = [
    { title: "Telemetry", enabled: true },
    { title: "Digital Key", enabled: true },
    { title: "Electric", enabled: false },
  ];
}
